import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';

import { defaultMapper } from './getSortOrder';

// адаптация виртуальной колонки year, добавляемой в mapRawToPlan, для работы с fetchPlans и сущностями индекса KnmPlanIndex
export function getSortOrderByYear<T>(col: ITableColumn<T>): string {
  if (col.id === 'year') {
    return `startDate,${col.sort};endDate,${col.sort}`;
  }

  return defaultMapper<T>(col);
}
